import React from "react"
import { Redirect, Route, Switch } from "react-router"
import Queries from "../modules/queries/queries"
import SecurityCriteria from "../modules/security/criteria/security-criteria"
import SecurityResults from "../modules/security/result/security-result"
import SecurityDetail from    "../modules/security/detail/security-detail"
import SecuritySavePage from    "../modules/security/savePage/security-savePage"
import NoMatch from "./no-match"
//import { queries } from "@testing-library/react"

/*
const routes = (
    <Switch>
      <Redirect exact from="/" to="/filestores" />
      <Route path="/filestores" component={FilestoreList} exact />
      <Route path="/filestores/create" component={CreateFilestore} exact />
      <Route path="/filestores/:filestoreId" component={EditFilestore} />
      <Route path="/nodes" component={NodeList} exact />
      <Route path="/nodes/:nodeId" component={EditNode} />
      <Route path="/apps" component={AppList} exact />
      <Route path="/settings" component={Settings} />
      <Route component={NoMatch} />
    </Switch>
  )
  
  export default routes

  <NoMatch adtx="Waiting to be implemented"/> 
  */

  const routes = (
    <Switch>
        <Redirect exact from="/" to="/queries" />
        <Route path="/queries" exact >
            <Queries/>
        </Route>
        {/* Securities follow the same schema as depositories. Side effects handled via sagas */}
        <Route path="/securitycriteria" exact >
            <SecurityCriteria/>
        </Route>
        <Route path="/securityresults" exact >
            <SecurityResults/>            
        </Route>
        <Route path="/security/:commoncode" component={SecurityDetail} />
        <Route path="/SaveAs">
            <SecuritySavePage/>
        </Route>
        <Route>
            <NoMatch/>
        </Route>
  </Switch>
  )

  export default routes